import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

import CustomToolbar from "../components/CustomToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateHospitalContractCampaign = () => {
  return (
    <Create
      title="Създаване на договор с болница"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateHospitalContractCampaign;
